import React from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tabs, Tab } from "@mui/material";
import TeamList from "../../features/manageMaintenanceTeam/teamList";
import TeamTopbar from "../../features/manageMaintenanceTeam/topbar";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageMaintenanceTeam = () => {

  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Maintenance Team</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Maintenance Team
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Approved Team" {...a11yProps(0)} />
              <Tab label="Pending Team" {...a11yProps(1)} />
              <Tab label="Rejected Team" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <TeamTopbar />

        <CustomTabPanel value={valueTabs} index={0}>
          <TeamList />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <TeamList />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <TeamList />
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default ManageMaintenanceTeam;
